<template>
  <section>
    <!--工具条-->
    <BusLinesToolbar :buttonList="buttonList" @callFunction="callFunction"></BusLinesToolbar>

    <!--列表-->
    <el-table :data="busLiness" highlight-current-row v-loading="listLoading" @current-change="selectCurrentRow"
      style="width: 100%;">
      <el-table-column fixed="left" type="index" label="序号" width="80"></el-table-column>
      <el-table-column fixed="left" label="操作" width="80">
        <template slot-scope="scope">
          <span v-for="item in operationButtonList" :key="item.id">
            <el-button type="text" style="padding-right:6px;" size="small" v-if="!item.IsHide"
              @click="operationButtonFunction(item,scope.row)">{{item.name}}</el-button>
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="OwnedCompany" label="所属公司" width="260" sortable></el-table-column>
      <el-table-column fixed="left" prop="LineTypeName" label="线路类型" width="100" sortable></el-table-column>
      <el-table-column fixed="left" prop="LineChineseName" label="线路中文名称" width="150" sortable></el-table-column>
      <el-table-column prop="LineEnglishName" label="线路英文名称" width="200" sortable></el-table-column>
      <el-table-column prop="LineMode" label="线路模式" width="100" sortable></el-table-column>
      <el-table-column prop="VehiclesNumber" label="配车数" width="100" :formatter="vehiclesNumberFormat" sortable></el-table-column>
      <el-table-column prop="AbnormalTime" label="异常间隔时间"  width="150" :formatter="abnormalTimeFormat" sortable></el-table-column>
      <el-table-column prop="MorningFastigiumTimeSlot" label="早高峰期" width="120"
        :formatter="morningFastigiumTimeSlotFormat" sortable></el-table-column>
      <el-table-column prop="NightFastigiumTimeSlot" label="晚高峰期" width="120" :formatter="nightFastigiumTimeSlotFormat"
        sortable></el-table-column>
      <el-table-column prop="FastigiumSpeed" label="高峰期速度" width="120" :formatter="fastigiumSpeedFormat" sortable>
      </el-table-column>
      <el-table-column prop="LowPeakPeriodSpeed" label="低峰期速度" width="120" :formatter="lowPeakPeriodSpeedFormat"
        sortable></el-table-column>
      <el-table-column prop="ApprovedMileage" label="核定里程" width="120" :formatter="approvedMileageFormat" sortable>
      </el-table-column>
      <el-table-column prop="ApprovedShift" label="核定班次" width="120" sortable></el-table-column>
      <el-table-column prop="FirstShiftTime" label="首班时间" width="150" sortable></el-table-column>
      <el-table-column prop="LastShiftTime" label="末班时间" width="150" sortable></el-table-column>
      <el-table-column prop="DepartureInterval" label="发车间隔" width="200" sortable></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" :formatter="formatCreateTime" width="120" sortable>
      </el-table-column>
      <el-table-column prop="Enabled" label="状态" width="200" sortable>
        <template slot-scope="scope">
          <el-tag :type="scope.row.Enabled  ? 'success' : 'danger'" disable-transitions>{{scope.row.Enabled ?
            "正常":"禁用"}}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination layout="total, sizes, prev, pager, next" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page.sync="page" :page-sizes="[10, 15, 20, 50, 100, 200]"
        :total="total" style="float:right;"></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog title="编辑" :visible.sync="editFormVisible" v-model="editFormVisible" :close-on-click-modal="false">
      <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
        <el-row>
          <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
            <el-select style="width: 100%;" v-model="editForm.CompanyId" placeholder="请选择所属公司">
              <el-option v-for="item in companys" :key="item.Id" :value="item.Id" :label="item.CompanyName">
                <span style="float: left">{{ item.CompanyName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="线路类型" prop="LineType" label-width="110px">
              <el-select v-model="editForm.LineType" placeholder="请选择线路类型">
                <el-option v-for="item in lineTypeList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路模式" prop="LineMode" label-width="110px">
              <el-select style="width: 100%;" v-model="editForm.LineMode" placeholder="请选择线路模式">
                <el-option v-for="item in lineModeList" :key="item.Id" :value="item.DictName" :label="item.DictName">
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13">
            <el-form-item label="线路中文名称" prop="LineChineseName" label-width="110px">
              <el-input style="width:187px;" v-model="editForm.LineChineseName" />
              <el-button type="primary" @click.native="editFormTranslation">翻译</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路英文名称" prop="LineEnglishName" label-width="110px">
              <el-input v-model="editForm.LineEnglishName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13">
            <el-form-item label="运营备注中文" prop="LineChineseRemark" label-width="110px">
              <el-input style="width:187px;" v-model="editForm.LineChineseRemark" />
              <el-button type="primary" @click.native="editFormRemarkTranslation">翻译</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="运营备注英文" prop="LineEnglishRemark" label-width="110px">
              <el-input v-model="editForm.LineEnglishRemark" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="百度线路名称" prop="BaiduMapLineName" label-width="110px">
              <el-input v-model="editForm.BaiduMapLineName" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="配车数" prop="VehiclesNumber" label-width="110px">
              <el-input v-number-only v-model="editForm.VehiclesNumber" style="width:130px" /> 辆
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="首班时间" prop="FirstShiftTime" label-width="110px">
              <el-time-picker v-model="editForm.FirstShiftTime" value-format="HH:mm" format="HH:mm" style="width:187px">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="末班时间" prop="LastShiftTime" label-width="110px">
              <el-time-picker v-model="editForm.LastShiftTime" value-format="HH:mm" format="HH:mm" style="width:187px">
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="发车间隔" prop="DepartureInterval" label-width="110px">
              <el-input v-model="editForm.DepartureInterval" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="序号" prop="Sort" label-width="110px">
              <el-input v-number-only v-model="editForm.Sort" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="高峰期速度" prop="FastigiumSpeed" label-width="110px">
              <el-input v-number-only v-model="editForm.FastigiumSpeed" style="width:130px" /> 公里/时
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="低峰期速度" prop="LowPeakPeriodSpeed" label-width="110px">
              <el-input v-number-only v-model="editForm.LowPeakPeriodSpeed" style="width:130px" /> 公里/时
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="早高峰期" prop="MorningFastigiumTimeSlot" label-width="110px">
              <el-time-picker is-range v-model="editForm.MorningFastigiumTimeSlot" value-format="HH:mm" format="HH:mm"
                range-separator="至" start-placeholder="开始时间" end-placeholder="截止时间" style="width:187px">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="晚高峰期" prop="NightFastigiumTimeSlot" label-width="110px">
              <el-time-picker is-range v-model="editForm.NightFastigiumTimeSlot" value-format="HH:mm" format="HH:mm"
                range-separator="至" start-placeholder="开始时间" end-placeholder="截止时间" style="width:187px">
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="核定里程" prop="ApprovedMileage" label-width="110px">
              <el-input @input="onlyNumber('Edit')" v-model="editForm.ApprovedMileage" style="width:130px" /> KM
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="核定班次" prop="ApprovedShift" label-width="110px">
              <el-input v-number-only v-model="editForm.ApprovedShift" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="异常时间间隔" prop="AbnormalTime" label-width="110px">
              <el-input v-number-only v-model="editForm.AbnormalTime" style="width:130px" /> 分钟
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="editForm.Enabled" placeholder="请选择线路状态">
                <el-option v-for="item in statusList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog title="新增" :visible.sync="addFormVisible" v-model="addFormVisible" :close-on-click-modal="false">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-form-item label="所属公司" prop="CompanyId" label-width="110px">
            <el-select style="width: 100%;" v-model="addForm.CompanyId" placeholder="请选择所属公司">
              <el-option v-for="item in companys" :key="item.Id" :value="item.Id" :label="item.CompanyName">
                <span style="float: left">{{ item.CompanyName }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="线路类型" prop="LineType" label-width="110px">
              <el-select v-model="addForm.LineType" placeholder="请选择线路类型">
                <el-option v-for="item in lineTypeList" :key="item.value" :label="item.name" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路模式" prop="LineMode" label-width="110px">
              <el-select style="width: 100%;" v-model="addForm.LineMode" placeholder="请选择线路模式">
                <el-option v-for="item in lineModeList" :key="item.Id" :value="item.DictName" :label="item.DictName">
                  <span style="float: left">{{ item.DictName }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13">
            <el-form-item label="线路中文名称" prop="LineChineseName" label-width="110px" :inline="true">
              <el-input style="width:187px;" v-model="addForm.LineChineseName" />
              <el-button type="primary" @click.native="addFormTranslation">翻译</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="线路英文名称" prop="LineEnglishName" label-width="110px">
              <el-input v-model="addForm.LineEnglishName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="13">
            <el-form-item label="运营备注中文" prop="LineChineseRemark" label-width="110px">
              <el-input style="width:187px;" v-model="addForm.LineChineseRemark" />
              <el-button type="primary" @click.native="editFormRemarkTranslation">翻译</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="运营备注英文" prop="LineEnglishRemark" label-width="110px">
              <el-input v-model="addForm.LineEnglishRemark" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="百度线路名称" prop="BaiduMapLineName" label-width="110px">
              <el-input v-model="addForm.BaiduMapLineName" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="配车数" prop="VehiclesNumber" label-width="110px">
              <el-input v-number-only v-model="addForm.VehiclesNumber" style="width:130px" /> 辆
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="首班时间" prop="FirstShiftTime" label-width="110px">
              <el-time-picker v-model="addForm.FirstShiftTime" value-format="HH:mm" format="HH:mm" style="width:187px">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="末班时间" prop="LastShiftTime" label-width="110px">
              <el-time-picker v-model="addForm.LastShiftTime" value-format="HH:mm" format="HH:mm" style="width:187px">
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="发车间隔" prop="DepartureInterval" label-width="110px">
              <el-input v-model="addForm.DepartureInterval" />
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="序号" prop="Sort" label-width="110px">
              <el-input v-number-only v-model="addForm.Sort" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="高峰期速度" prop="FastigiumSpeed" label-width="110px">
              <el-input v-number-only v-model="addForm.FastigiumSpeed" style="width:130px" /> 公里/时
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="低峰期速度" prop="LowPeakPeriodSpeed" label-width="110px">
              <el-input v-number-only v-model="addForm.LowPeakPeriodSpeed" style="width:130px" /> 公里/时
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="早高峰期" prop="MorningFastigiumTimeSlot" label-width="110px">
              <el-time-picker is-range v-model="addForm.MorningFastigiumTimeSlot" value-format="HH:mm" format="HH:mm"
                range-separator="至" start-placeholder="开始时间" end-placeholder="截止时间" style="width:187px">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="晚高峰期" prop="NightFastigiumTimeSlot" label-width="110px">
              <el-time-picker is-range v-model="addForm.NightFastigiumTimeSlot" value-format="HH:mm" format="HH:mm"
                range-separator="至" start-placeholder="开始时间" end-placeholder="截止时间" style="width:187px">
              </el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="核定里程" prop="ApprovedMileage" label-width="110px">
              <el-input @input="onlyNumber('Add')" v-model="addForm.ApprovedMileage" style="width:130px" /> KM
            </el-form-item>
          </el-col>
          <el-col :span="10" style="float:right;">
            <el-form-item label="核定班次" prop="ApprovedShift" label-width="110px">
              <el-input v-number-only v-model="addForm.ApprovedShift" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label="异常时间间隔" prop="AbnormalTime" label-width="110px">
              <el-input v-number-only v-model="addForm.AbnormalTime" style="width:130px" /> 分钟
            </el-form-item>
          </el-col>
           <el-col :span="10" style="float:right;">
            <el-form-item label="状态" prop="Enabled" label-width="110px">
              <el-select v-model="addForm.Enabled" placeholder="请选择线路状态">
                <el-option label="激活" value="true"></el-option>
                <el-option label="禁用" value="false"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--操作日记-->
    <el-dialog title="操作日记" :visible.sync="operateDataLogFormVisible" v-model="operateDataLogFormVisible"
      :close-on-click-modal="false" :destroy-on-close="true" width="60%">
      <OperateDataLog v-if="operateDataLogFormVisible" :entityName="entityName" :entityKey="entityKey"></OperateDataLog>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="operateDataLogFormVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getBusLinesListPage, removeBusLines, editBusLines, addBusLines, getCompanyListPage, baiduTrans, getDictionaryListPageByDictNameAndDictCode,verifyLineChineseNameExist,verifyLineEnglishNameExist } from "../../api/api";
import { getButtonList,getOperationButtonList } from "../../promissionRouter";
import BusLinesToolbar from "../../components/QueryToolbar/BusLinesToolbar";
import OperateDataLog from "../../components/OperateDataLog";

export default {
  components: { BusLinesToolbar,OperateDataLog },
  data() {
    let addLineChineseNameCheck = (rule, value, callback) => {
      if (value != "") {
        this.lineChineseNameRules(0,value,callback);
      }
    };
    let editLineChineseNameCheck = (rule, value, callback) => {
      if (value != "") {
        this.lineChineseNameRules(this.editForm.Id,value,callback);
      }
    };
    let addLineEnglishNameCheck = (rule, value, callback) => {
      if (value != "") {
        this.lineEnglishNameRules(0,value,callback);
      }
    };
    let editLineEnglishNameCheck = (rule, value, callback) => {
      if (value != "") {
        this.lineEnglishNameRules(this.editForm.Id,value,callback);
      }
    };
    return {
      filters: {
        lineName: ""
      },
      entityName: 'BusLines', //操作日记中的表名称
      entityKey: '',  //操作日记中的表的Id
      buttonList: [],
      operationButtonList: [],
      busLiness: [], //线路列表
      companys: [], //企业列表
      lineModeList: [], //线路模式列表
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false }
      ],
      lineTypeList: [
        { name: "村村通", value: 1 },
        { name: "实时公交", value: 2 },
        { name: "跨市县公交", value: 3 }
      ],
      total: 0,
      page: 1,
      pageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      operateDataLogFormVisible: false, //查看操作日记界面是否显示
      editLoading: false,
      editFormRules: {
        CompanyId: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
        LineType: [{ required: true, message: "请选择线路类型", trigger: "blur" }],
        LineMode: [{ required: true, message: "请输入线路模式", trigger: "blur" }],
        LineChineseName: [{ required: true, message: "请输入线路中文名称", trigger: "blur" },{ validator: editLineChineseNameCheck, trigger: "blur" }],
        BaiduMapLineName: [{ required: true, message: "请输入百度地图公交线路名称", trigger: "blur" }],
        FastigiumSpeed: [{ required: true, message: "请输入高峰期速度", trigger: "blur" }],
        LowPeakPeriodSpeed: [{ required: true, message: "请输入低峰期速度", trigger: "blur" }],
        ApprovedMileage: [{ required: true, message: "请输入核定里程", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }]
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        CreateBy: "",
        CompanyId: 0,
        LineType: "",
        Sort: 0,
        Enabled: false,
        LineMode: "",
        LineChineseName: "",
        LineEnglishName: "",
        LineChineseRemark: "",
        LineRemarkEnglishName: "",
        BaiduMapLineName: "",
        VehiclesNumber: 0,
        MorningFastigiumTimeSlot:"",
        NightFastigiumTimeSlot:"",
        FastigiumSpeed:0,
        LowPeakPeriodSpeed:0,
        DepartureInterval: "",
        FirstShiftTime: "",
        LastShiftTime: "",
        ApprovedMileage: 0,
        ApprovedShift: "",
        AbnormalTime:""
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        CompanyId: [{ required: true, message: "请输入所属公司", trigger: "blur" }],
        LineType: [{ required: true, message: "请选择线路类型", trigger: "blur" }],
        LineMode: [{ required: true, message: "请输入线路模式", trigger: "blur" }],
        LineChineseName: [{ required: true, message: "请输入线路中文名称", trigger: "blur" },{ validator: addLineChineseNameCheck, trigger: "blur" }],
        BaiduMapLineName: [{ required: true, message: "请输入百度地图公交线路名称", trigger: "blur" }],
        FastigiumSpeed: [{ required: true, message: "请输入高峰期速度", trigger: "blur" }],
        LowPeakPeriodSpeed: [{ required: true, message: "请输入低峰期速度", trigger: "blur" }],
        ApprovedMileage: [{ required: true, message: "请输入核定里程", trigger: "blur" }],
        Enabled: [{ required: true, message: "请选择状态", trigger: "blur" }]
      },
      //新增界面数据
      addForm: {
        CreateBy: "",
        CreateId: "",
        CompanyId: 0,
        LineType: 1,
        Sort: 0,
        Enabled: "true",
        LineMode: "",
        LineChineseName: "",
        LineEnglishName: "",
        LineChineseRemark: "",
        LineRemarkEnglishName: "",
        BaiduMapLineName: "",
        VehiclesNumber: 0,
        MorningFastigiumTimeSlot:"",
        NightFastigiumTimeSlot:"",
        FastigiumSpeed:0,
        LowPeakPeriodSpeed:0,
        DepartureInterval: "",
        FirstShiftTime: "",
        LastShiftTime: "",
        ApprovedMileage: 0,
        ApprovedShift: "",
        AbnormalTime:""
      }
    };
  },
  methods: {
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    addFormTranslation: function(){
      let para = {q: this.addForm.LineChineseName };
      baiduTrans(para).then(res => {
        this.addForm.LineEnglishName = res.data.response;
      });
    },
    editFormTranslation: function(){
      let para = {q: this.editForm.LineChineseName };
      baiduTrans(para).then(res => {
        this.editForm.LineEnglishName = res.data.response;
      });
    },
    addFormRemarkTranslation: function(){
      let para = {q: this.addForm.LineChineseRemark };
      baiduTrans(para).then(res => {
        this.addForm.LineRemarkEnglishName = res.data.response;
      });
    },
    editFormRemarkTranslation: function(){
      let para = {q: this.editForm.LineChineseRemark };
      baiduTrans(para).then(res => {
        this.editForm.LineRemarkEnglishName = res.data.response;
      });
    },
    callFunction(item) {
      this.filters = {
        lineName: item.lineName
      };
      this[item.Func].apply(this, item);
    },
    operationButtonFunction(item,row){
      this.currentRow = row;
      this[item.Func].apply(this,item);
    },
    //性别显示转换
    formatEnabled: function(row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function(row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    vehiclesNumberFormat(row, column) {
      return row.VehiclesNumber + ' 辆';
    },
    fastigiumSpeedFormat(row, column) {
      return row.FastigiumSpeed + ' 公里/时';
    },
    lowPeakPeriodSpeedFormat(row, column) {
      return row.LowPeakPeriodSpeed + ' 公里/时';
    },
    morningFastigiumTimeSlotFormat(row, column) {
      if(row.MorningFastigiumTimeSlot !== "" && row.MorningFastigiumTimeSlot !== null){
        return row.MorningFastigiumTimeSlot.replace(","," 至 ");
      }
    },
    nightFastigiumTimeSlotFormat(row, column) {
      if(row.NightFastigiumTimeSlot !== "" && row.NightFastigiumTimeSlot !== null){
        return row.NightFastigiumTimeSlot.replace(","," 至 ");
      }
    },
    approvedMileageFormat(row, column) {
      return row.ApprovedMileage + ' KM';
    },
    abnormalTimeFormat(row, column) {
      return row.AbnormalTime + ' 分钟';
    },
    // 保留两位小数
    // replace(/[^\d.]/g,"") //清除非 数字和小数点的字符
    // 清除第二个小数点
    // .replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3'); //保留两位小数
    onlyNumber(type) {
      if (type === "Add")
        this.addForm["ApprovedMileage"] = this.addForm["ApprovedMileage"].replace(/[^\d.]/g, "").replace(/\.{2,}/g, ".").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      else if (type === "Edit")
        this.editForm["ApprovedMileage"] = this.editForm["ApprovedMileage"].replace(/[^\d.]/g, "").replace(/\.{2,}/g, ".").replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    },
    handleSizeChange(val) {
      this.page = 1;
      this.pageSize = val;
      this.getBusLines();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getBusLines();
    },
    queryBusLines(){
      this.page = 1;
      this.getBusLines();
    },
    //获取线路列表
    getBusLines() {
      let _this = this;
      let para = {
        lineName: _this.filters.lineName,
        enabled: null,
        page: _this.page,
        pageSize: _this.pageSize
      };
      _this.listLoading = true;
      getBusLinesListPage(para).then(res => {
        _this.total = res.data.response.dataCount;
        _this.busLiness = res.data.response.data;
        _this.listLoading = false;
      });
    },
    //校验线路中文名称是否已经存在
    lineChineseNameRules(id,value,callback) {
      let para = {
        lineChineseName: value,
        id:id
      };
      verifyLineChineseNameExist(para).then(res => {
        if(res.data){
          callback(new Error("线路中文名称已存在，请重新输入"));
        }
        callback();
      });
    },
    //校验线路英文名称是否已经存在
    lineEnglishNameRules(id,value,callback) {
      let para = {
        lineEnglishName: value,
        id:id
      };
      verifyLineEnglishNameExist(para).then(res => {
        if(res.data){
          callback(new Error("线路英文名称已存在，请重新输入"));
        }
        callback();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning"
      })
      .then(() => {
        this.listLoading = true;
        let para = { id: row.Id };
        removeBusLines(para).then(res => {
          if (util.isEmt.format(res)) {
            this.listLoading = false;
            return;
          }
          this.listLoading = false;
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error"
            });
          }

          this.getBusLines();
        });
      })
      .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error"
        });

        return;
      }

      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.editForm.MorningFastigiumTimeSlot= this.editForm.MorningFastigiumTimeSlot === "" || this.editForm.MorningFastigiumTimeSlot === null?this.editForm.MorningFastigiumTimeSlot:this.editForm.MorningFastigiumTimeSlot.split(',');
      this.editForm.NightFastigiumTimeSlot= this.editForm.NightFastigiumTimeSlot === "" || this.editForm.NightFastigiumTimeSlot === null?this.editForm.NightFastigiumTimeSlot:this.editForm.NightFastigiumTimeSlot.split(',');
      this.editForm.LineType = this.editForm.LineType === 0?"": this.editForm.LineType;
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        CreateBy: "",
        CompanyName: "",
        Enabled: "true"
      };
    },
    //查看操作日记
    lookUpOperateDataLog() {
      this.operateDataLogFormVisible = true;
      this.entityKey = this.currentRow.Id;
    },
    //编辑
    editSubmit: function() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.MorningFastigiumTimeSlot = para.MorningFastigiumTimeSlot !== undefined && para.MorningFastigiumTimeSlot !== "" && para.MorningFastigiumTimeSlot !== null ? para.MorningFastigiumTimeSlot.toString() : null;
            para.NightFastigiumTimeSlot = para.NightFastigiumTimeSlot !== undefined && para.NightFastigiumTimeSlot !== "" && para.NightFastigiumTimeSlot !== null ? para.NightFastigiumTimeSlot.toString() : null;

            editBusLines(para).then(res => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }

              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getBusLines();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function() {
      let _this = this;
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.MorningFastigiumTimeSlot = para.MorningFastigiumTimeSlot !== undefined && para.MorningFastigiumTimeSlot !== "" && para.MorningFastigiumTimeSlot !== null ? para.MorningFastigiumTimeSlot.toString() : null;
            para.NightFastigiumTimeSlot = para.NightFastigiumTimeSlot !== undefined && para.NightFastigiumTimeSlot !== "" && para.NightFastigiumTimeSlot !== null ? para.NightFastigiumTimeSlot.toString() : null;

            var user = JSON.parse(window.localStorage.user);

            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error"
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addBusLines(para).then(res => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success"
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getBusLines();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error"
                });
              }
            });
          });
        }
      });
    },
    selsChange: function(sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function() {
      this.$message({
        message: "该功能未开放",
        type: "warning"
      });
    },
    getButtonList2(routers) {
      let _this = this;
      routers.forEach(element => {
        let path = this.$route.path.toLowerCase();
        if (element.path && element.path.toLowerCase() == path) {
          _this.buttonList = element.children;
          return;
        } else if (element.children) {
          _this.getButtonList(element.children);
        }
      });
    }
  },
  mounted() {
    this.getBusLines();

    getCompanyListPage().then(res => {
      this.companys = res.data.response.data;
    });

    let para = {
        dictName: '线路模式',
        dictCode: 'LineMode',
        pageSize: 100
      };
    getDictionaryListPageByDictNameAndDictCode(para).then(res => {
      this.lineModeList = res.data.data;
    });

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    //第一种写法，每个页面都需要写方法，但是可以做特性化处理
    // this.getButtonList(routers);

    //第二种写法，封装到 permissionRouter.js 中
    this.buttonList = getButtonList(this.$route.path, routers);
    this.operationButtonList = getOperationButtonList(this.$route.path, routers);
  }
}
</script>

<style scoped>

</style>
